// src/app/guards/privacy.guard.ts
import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { PrivacyService } from '../privacy/privacy.service';

export const privacyGuard: CanActivateFn = (route, state) => {
  const privacyService = inject(PrivacyService); // Inject the PrivacyService using Angular's DI
  const router = inject(Router); // Inject Router

  console.log('Privacy Accepted:', privacyService.isPrivacyAccepted()); // Log current acceptance status

  if (privacyService.isPrivacyAccepted()) {
    return true; // Allow navigation
  } else {
    router.navigate(['']); // Redirect to the landing page if privacy is not accepted
    return false; // Prevent navigation
  }
};
